module.exports = __webpack_public_path__ + "static/media/splash.1f3156a1.png";